import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Drawer as BPDrawer } from '@blueprintjs/core';
import './Drawer.scss';

export const Drawer = ({children, ...props}) => {
  return (
    <BPDrawer
      {...props}
      className={cx('drawer', props.className || null)}
    >
      {children}
    </BPDrawer>
  );
};
Drawer.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  className: PropTypes.string,
};